import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid } from '@material-ui/core';
// import { PaymentsTable } from 'components/Tables';
import { useStyles } from './styles';
import { PaymentsTable } from 'components/Tables';

const Payments: FC = observer(() => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'EasyIdentity: Payments';
  }, []);

  return (
    // <Container maxWidth='xl' className={classes.container}>
    //   <PaymentsTable />
    // </Container>
    <Container maxWidth='xl' className={classes.container}>
      <Grid className={classes.infoContainer} container alignItems='stretch' justify='space-between' spacing={3}>
        <PaymentsTable />
      </Grid>
    </Container>
  );
});

export default Payments;
